import { paypalActions } from "../../actionTypes";

const initialState = {
	subscription: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case paypalActions.SWAP_PAYPAL_SUBSCRIPTION: {
			return { ...initialState, fetching: true };
		}

		case paypalActions.SWAP_PAYPAL_SUBSCRIPTION_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				subscription: action.payload,
			};
		}

		case paypalActions.SWAP_PAYPAL_SUBSCRIPTION_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
